/* Component in IndexShots to display each the IndexShot
 * Contains a link to IndexShotsFullSize to view the Image full size
 * Contains the IndexShotEdit component */
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Card from "react-bootstrap/Card"
import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import styles from "../../styles/Indexes.module.css"
import IndexShotEdit from "./IndexShotEdit"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import toast from "react-hot-toast";

const IndexShot = (props) => {
  const host = useHostName()
  const [showEdit, setShowEdit] = useState(false)
  const history = useHistory();
  const { id, number, content, image, shot, ser_id,
    setHasOrder, setIndexShots } = props
  const currentUser = useCurrentUser()

  const handleEdit = () => {
    setShowEdit(true)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/indexshots/${id}/`)
        toast.success(`Indexshot Deleted`);
        setHasOrder(true)
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/indexshots/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Indexshot Deleted Successfully!`);
        setHasOrder(true)
      }
    } catch (err) { }
  }

  const handleClickFull = () => {
        // setImage(image); 
        history.push(`/${localStorage.getItem("projectSlug")}/indexshots/fullsize/${id}`);  
      };

  const [contentType, setContentType] = useState(null);

  const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
  };

  const getContentTypeWithGET = async (url) => {
    try {
      const res = await fetch(url, { method: "GET", cache: "no-store" });
      return res.headers.get("Content-Type");
    } catch (err) {
      console.error("Error fetching content type:", err);
      return null;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps -- re-fetch only when shot image ref changes
  useEffect(() => {
    if (shot?.image) {
      getContentTypeWithGET(image).then(setContentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shot?.image]);

  return (
    <div className='mt-3'>
    <Card className={`text-center p-0 ${styles.Card1 }`}>
    <Card.Header className={`py-0 ${styles.TopCard }`}>
      <Row className='d-flex align-items-center' >
    <Col className='mx-0 px-0' xs={4}>
    <p className={`float-left mb-0 pb-0 ml-3 ${styles.FullsizeText }`}
                        onClick={() => handleClickFull() }>FULLSIZE</p>
    </Col>
    <Col xs={4} className='mx-0 px-0 
    d-flex align-items-center justify-content-center'>
      <p className={` ${styles.Small }`}>{number}
              </p>
    </Col >
    <Col xs={3}></Col>
    {
    currentUser?.groups[0]?.name !== "Crew" &&
    <Col xs={1} className={` ${styles.Drop } text-center mx-0 px-0 py-0`}>
    <div>
    <PostDropdown
        handleEdit={handleEdit}
        handleDelete={handleDelete}
    />
    </div>
    </Col>
    }
    </Row>
    </Card.Header>
    {/* <Link to={`/${localStorage.getItem("projectSlug")}/indexshots/fullsize/${id}`}> */}
    <Card.Body className={` p-0 `}>
    <Row>
        <Col className="mt-0" xs={12}>
        {shot?.image && contentType && (
            <>
            {isImageFile(contentType) ? (
                <figure className="m-0 px-3 text-center">
                <Card.Img
                    className={`${styles.ImagesIndex} rounded`}
                    src={shot.image}
                    alt="shot"
                />
                </figure>
            ) : contentType === "application/pdf" ? (
                <iframe
                src={shot.image}
                allow="fullscreen"
                title="pdf"
                className={styles.iframe}
                // width="50%"
                // height="235"
                // style={{ border: "1px solid #ccc" }}
                />
            ) : (
                <p>Unsupported file type: {contentType}</p>
            )}
            </>)}
            <Row>
            <Col xs={12} className='mx-0 px-0 '>
              <div className={`pt-1 px-3 ${styles.TopCard2 }`}>
              <p className={` ${styles.Titlelist }`}>{content}</p>
              </div>
              </Col >
            </Row>
        </Col>
    </Row>
    </Card.Body>
    {/* </Link> */}
    </Card>
    {
    currentUser?.groups[0]?.name !== "Crew" &&
    <>
        {!showEdit ? (
        ""
        ) : (
        <IndexShotEdit
            setIndexShots={setIndexShots}
            shot={shot}
            ser_id={ser_id}
            id={id}
            setShowEdit={setShowEdit}
            setHasOrder={setHasOrder}
        />
        )}
    </>
    }
    </div>
  )
}
export default IndexShot
